import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Container = styled.div``;

export const Scroll = styled.div`
overflow-x: auto;
`;

export const StyledLink = styled(Link)`
color: ${colors.LightBlue};
`;

export const TruncatedTextWrapper = styled.div`
  position: relative;
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const Tooltip = styled.div<{ top: number; left: number }>`
  position: fixed;
  top: ${(p) => p.top}px;
  left: ${(p) => p.left}px;
  background-color: #333;
  color: white;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.875rem;
  z-index: 9999;
  max-width: 300px;
  white-space: normal;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.2);
`;

export const ButtonExport = styled.button`
  color: ${colors.BlueSecondary};
  border: 1px solid ${colors.BlueSecondary};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;
